if (!window.jfBuyNowInitialized) {
  window.jfBuyNowInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.jf-buy-now');
    if (!button) return;

    const form = document.getElementById(button.dataset.productForm);
    if (!form) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    returnTo.value = `${window.Shopify.routes.root}checkout`;

    button.disabled = true;
    HTMLFormElement.prototype.submit.call(form);
  });
}
